import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface AboutUsState {
}

const initialState: AboutUsState = {
}

export const AboutUsSlice = createSlice({
    name: 'aboutUs',
    initialState,
    reducers: {
    }
});

export const { } = AboutUsSlice.actions;

export const selectState = (state: RootState) => state.aboutUs;

export default AboutUsSlice.reducer;